var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.021 16.167q-.521 0-.854-.334-.334-.333-.334-.854V7.021q0-.521.334-.854.333-.334.854-.334h3.812v-1q0-.5.334-.833.333-.333.854-.333H11q.5 0 .833.333.334.333.334.854v.979h3.812q.521 0 .854.334.334.333.334.854v7.958q0 .521-.334.854-.333.334-.854.334Zm0-.667h11.958q.209 0 .365-.156t.156-.365V7.021q0-.209-.156-.365t-.365-.156H4.021q-.209 0-.365.156t-.156.365v7.958q0 .209.156.365t.365.156ZM8.5 5.833h3v-.979q0-.208-.156-.364-.156-.157-.365-.157H9.021q-.209 0-.365.157-.156.156-.156.364Zm-5 9.667V6.5 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientId);
export default __webpack_public_path__ + "static/media/patient-id.a714c2a377f511fb36cae785b26b561b.svg";
export { ForwardRef as ReactComponent };